import PropTypes from 'prop-types';
import ContactTagList from 'apps/contact/components/contact-tag-list';
import { useProposalFormContext } from '../context/proposal-form-context';

const ContactField = ({ onChange = () => null, onBlur = () => null, name = '', value = [], contactId }) => {
  const { additionalContactLimit } = useProposalFormContext();

  return (
    <>
      {additionalContactLimit > 0 ? (
        <ContactTagList
          testId="contacts"
          placeholder="Search for a prospect to add..."
          contactsFilterFunction={(contactFilter = {}) => contactFilter.id !== contactId}
          selected={value}
          disabled={value?.length >= additionalContactLimit}
          onSelect={(selectedContacts) => {
            onChange({ target: { name, value: selectedContacts } });
          }}
          onBlur={(e) => {
            onBlur({ target: { name } });
          }}
          focusOnMount={false}
        />
      ) : null}
    </>
  );
};

ContactField.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.array,
  contactId: PropTypes.number,
};

export default ContactField;
